import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';
import type { BbchInfo } from '../../../types/simulation';
import {
  BBCH_CONFIDENCE_LABELS,
  BBCH_CROP_GROUP_LABELS,
  BBCH_PRINCIPAL_LABELS,
} from '../../../pages/plantings/planting-details/constants';

const { Text } = Typography;

interface PlantingBbchTagProps {
  bbch?: BbchInfo | null;
  fallback?: React.ReactNode;
}

export const isDisplayablePlantingBbch = (bbch?: BbchInfo | null): boolean => {
  if (!bbch) return false;
  if (bbch.status === 'not_applicable' || bbch.status === 'unmapped') return false;
  return bbch.code != null;
};

const formatBbchTooltip = (bbch: BbchInfo): string => {
  const principal = bbch.principalStage ?? null;
  const principalText = principal != null
    ? `${BBCH_PRINCIPAL_LABELS[principal] || `ПС ${principal}`}`
    : '';
  const parts = [
    principalText,
    bbch.label,
    bbch.cropGroup ? `Группа: ${BBCH_CROP_GROUP_LABELS[bbch.cropGroup] || bbch.cropGroup}` : null,
    bbch.confidence ? `Доверие: ${BBCH_CONFIDENCE_LABELS[bbch.confidence] || bbch.confidence}` : null,
  ].filter(Boolean);
  return parts.join('\n');
};

const PlantingBbchTag: React.FC<PlantingBbchTagProps> = ({ bbch, fallback = null }) => {
  if (!isDisplayablePlantingBbch(bbch)) {
    return fallback ? <Text type="secondary">{fallback}</Text> : null;
  }

  const tooltip = formatBbchTooltip(bbch!);
  const tag = <Tag color="geekblue">BBCH {bbch!.code}</Tag>;
  if (!tooltip) return tag;

  return (
    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>}>
      {tag}
    </Tooltip>
  );
};

export default PlantingBbchTag;
